package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_new_shop


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("createShop")
    val createShop: CreateShop?,
    @SerialName("__typename")
    val typename: String?
)